<template>
  <v-row>
    <v-col cols="12" :md="modalView ? 12 : 6" :offset-md="modalView ? 0 : 3">
      <form @submit.prevent="save">
        <v-text-field
          v-model="form.name"
          label="Ime skupine *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.name.required)"
        >
          <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
        </FormErrors>
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.color"
              label="Barva"
              :disabled="true"
            ></v-text-field>
          </v-col>
          <v-col>
            <ColorPicker v-model="color" />
          </v-col>
        </v-row>
        <v-checkbox
          color="#0F998E"
          v-model="form.is_visible"
          label="Je vidna"
        ></v-checkbox>
        <v-checkbox
          color="#0F998E"
          v-if="false /*hack*/"
          v-model="sortOrderCheckbox"
          label="Samodejno nastavi vrstni red"
          @change="toggleAutoSortOrder"
        ></v-checkbox>
        <v-text-field
          v-if="!sortOrderCheckbox"
          v-model="form.sort_order"
          type="number"
          label="Željena pozicija skupine"
        ></v-text-field>
<!--         <v-text-field
          v-model="form.printer"
          label="Printer"
        ></v-text-field> -->
        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn v-if="!modalView && isNewCategory" type="button" class="float-right mr-4" @click="saveAndRepeat">Shrani in dodaj novo</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="cancel">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import ColorPicker from '@/components/ColorPicker'
import { mapActions } from 'vuex'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    ColorPicker
  },
  props: {
    category: {
      default: () => {},
      type: Object
    },
    modalView: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      sortOrderCheckbox: true,
      color: '#000000',
      emptyForm: {
        name: null,
        color: '#000000',
        is_visible: true,
        sort_order: null,
      },
      form: {}
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  computed: {
    isNewCategory () {
      return !this.category || Object.values(this.category).length === 0
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    saveAndRepeat () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form, repeat: true })
      }
    },
    clearForm () {
      this.form = { ...this.emptyForm }
      this.color = '#000000'
      this.$v.$reset()
    },
    cancel () {
      if (this.modalView) {
        this.$emit('cancel')
      } else {
        this.$router.go(-1)
      }
    },
    toggleAutoSortOrder () {
      if (this.sortOrderCheckbox) {
        this.form.sort_order = null
      }
    }
  },
  created () {
    this.form = { ...this.emptyForm }
    if (!this.isNewCategory) {
      this.form = { ...this.form, ...this.category }
      this.color = this.category.color
    }
  },
  watch: {
    color (color) {
      this.form.color = color
    }
  }
}
</script>
